import { render, staticRenderFns } from "./OfferConfigureStepLetter.vue?vue&type=template&id=22f442e9&scoped=true&"
import script from "./OfferConfigureStepLetter.vue?vue&type=script&lang=js&"
export * from "./OfferConfigureStepLetter.vue?vue&type=script&lang=js&"
import style0 from "./OfferConfigureStepLetter.vue?vue&type=style&index=0&id=22f442e9&scoped=true&lang=css&"
import style1 from "./OfferConfigureStepLetter.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f442e9",
  null
  
)

export default component.exports